import React, { useState, useRef } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BranchDropDown,
  CarerTypeDropDown,
  FormDatePicker,
  FormInput,
  IsCompliantDropdown,
  LoadingComponent,
  MoreOptions,
  PreviewCard,
  ReactDataTable,
  StatusActiveDropDown,
  ReportStatusDropdown,
} from "../../../components/Component";
import { carerListApi, carerTableColumns, exportCarerAPI, exportCarerProgressReportAPI } from "./CarerData";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useEffect } from "react";
import AddNotes from "../notes/AddNote";
import { PER_PAGE_ITEMS, ServerStatusType } from "../../../utils";
import { NoteUserType } from "../notes/NoteList";
import Sms from "../sms/Sms";
import { ImportExportButton } from "../../../components/button/ActionButton";
import ImportFileModal from "../../../components/ImportFileModal/ImportFileModal";
import SendEmailModal from "../invoices/invoiceEmail/SendEmailModal";
import {
  UserActionType,
  UserPermissionType,
  isAllowToAccess,
  isCheckToList,
} from "../../../services/permission/permission";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { openLinkInNewTab, scrollToTop } from "../../../utils/Functions";
import { GradeTypeDropDownWithoutCarer } from "../../../components/dropdowns/GradeTypeDropDown";
import {
  useGradeData,
  useCarerTypeData,
  statusOptions,
  ReportStatusTypes,
  CompliantDropdownOptions,
  parseUrlParams,
  updateHash,
  removeWhitespace,
  useBranchData,
} from "../../../utils/Utils";
import moment from "moment";

const formatMonthParam = (date) => moment(date).startOf("month").format("YYYY-MM-DD");

const CarerList = () => {
  const history = useHistory();
  const location = useLocation();

  // Report routes reuse this list with progress-report or active-rota filters
  const isActiveCarersReport = location.pathname.includes("/reports/active-carers");
  const isReportRoute = location.pathname.includes("/reports/carers") || isActiveCarersReport;
  const pageTitle = isActiveCarersReport ? "Active Carers" : "Carers";
  const statusData = location?.state?.status;
  const [status, setStatus] = useState();
  const [progressStatus, setProgressStatus] = useState();
  const [grade, setGrade] = useState();
  const [carerType, setCarerType] = useState();
  const [isCompliant, setIsCompliant] = useState();
  const [searchText, setSearchText] = useState();
  const [branch, setBranch] = useState();
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [month, setMonth] = useState("");
  // Active Carers: show/send current month by default without writing it into URL state
  const activeCarersMonth = formatMonthParam(new Date());
  const requestMonth = isActiveCarersReport ? month || activeCarersMonth : month || null;
  const pickerMonth = selectedMonth || (isActiveCarersReport ? moment(activeCarersMonth, "YYYY-MM-DD").toDate() : null);
  const [carerList, setCarerList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [emailModal, setEmailModal] = useState(false);
  const [smsModal, setSmsModal] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState();
  const [initScreen, setInitScreen] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const isRowSelected = selectedRows?.length > 0;
  const selectedRowIds = selectedRows.map((row) => row);
  const emailList = selectedRows.map((item) => item.email);
  const [loading, setLoading] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [sortId, setSortId] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const updatedGradeData = useGradeData();
  const updatedBranchData = useBranchData();
  const updatedCarerTypeData = useCarerTypeData();
  const prevPathnameRef = useRef(location.pathname);
  const onImport = () => {
    setImportModalOpen(true);
  };
  useEffect(() => {
    if (!currentPage) return;
    callCarerListApi();
  }, [currentPage]);
  useEffect(() => {
    if (initScreen) return;
    if (currentPage === 1) {
      callCarerListApi();
    } else {
      setCurrentPage(1);
    }
  }, [isCompliant, status, progressStatus, searchText, sortId, sortOrder, grade, branch, carerType, isReportRoute, isActiveCarersReport, month]);

  // Clear filters when navigating to report carers routes or on first load
  useEffect(() => {
    if (isReportRoute) {
      const prevPathname = prevPathnameRef.current;
      const currentPathname = location.pathname;
      const wasReportRoute =
        prevPathname.includes("/reports/carers") || prevPathname.includes("/reports/active-carers");
      const isTransitioningToReports = !wasReportRoute && isReportRoute;
      const isFirstLoadOnReports = prevPathname === currentPathname && initScreen;

      // Clear filters when transitioning to reports route or on first load
      if (isTransitioningToReports || isFirstLoadOnReports) {
        // Clear search text and filters
        setSearchText("");
        setGrade(undefined);
        setIsCompliant(undefined);
        setCarerType(undefined);

        // Clear search and other filters from URL hash (keep area manager)
        const params = parseUrlParams();
        if (params.search || params.grade || params.compliant || params.carerType) {
          updateHash({
            pathname: location.pathname,
            page: params.page,
            progressStatus: params.progressStatus,
            branch: params.branch,
            // Explicitly exclude search, grade, compliant, carerType
          });
        }
      }
      prevPathnameRef.current = currentPathname;
    } else {
      prevPathnameRef.current = location.pathname;
    }
  }, [location.pathname, isReportRoute, initScreen]);
  useEffect(() => {
    const params = parseUrlParams();
    if (params.page) {
      setCurrentPage(parseInt(params.page, 10));
    } else {
      setCurrentPage(1);
    }

    if (params.branch && !isActiveCarersReport) {
      const selectedBranch = updatedBranchData.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.branch),
      );
      if (selectedBranch && selectedBranch.value !== branch?.value) {
        setBranch(selectedBranch);
      }
    }

    // Don't read other filters from URL when on reports route (except status and page)
    if (!isReportRoute) {
      if (params.grade) {
        const matchedGrade = updatedGradeData.find(
          (item) => removeWhitespace(item.value) === removeWhitespace(params.grade),
        );
        if (matchedGrade && matchedGrade.value !== grade?.value) {
          setGrade(matchedGrade);
        }
      }
      if (params.carerType) {
        const matchedCarerType = updatedCarerTypeData?.find(
          (item) => removeWhitespace(item.value) === removeWhitespace(params.carerType),
        );
        if (matchedCarerType && matchedCarerType.value !== carerType?.value) {
          setCarerType(matchedCarerType);
        }
      }
      if (params.compliant) {
        const selectedCompliant = CompliantDropdownOptions.find(
          (option) => removeWhitespace(option.value) === removeWhitespace(params.compliant),
        );
        if (selectedCompliant && selectedCompliant.value !== isCompliant?.value) {
          setIsCompliant(selectedCompliant);
        }
      }
      if (params.search) {
        const searchQuery = decodeURIComponent(params.search);
        setSearchText(searchQuery);
      }
    }

    if (params.month) {
      const monthDate = moment(params.month, "YYYY-MM-DD").toDate();
      setSelectedMonth(monthDate);
      setMonth(formatMonthParam(monthDate));
    } else {
      setSelectedMonth(null);
      setMonth("");
    }

    // Read status for regular route
    if (!isReportRoute && params.status) {
      const selectedStatus = statusOptions.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.status),
      );
      if (selectedStatus && selectedStatus.value !== status?.value) {
        setStatus(selectedStatus);
      }
    }

    // Read progressStatus for report route (only use progressStatus parameter, ignore status)
    if (isReportRoute && params.progressStatus) {
      const selectedProgressStatus = ReportStatusTypes.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.progressStatus),
      );
      if (selectedProgressStatus && selectedProgressStatus.value !== progressStatus?.value) {
        setProgressStatus(selectedProgressStatus);
      }
    }
  }, [location]);
  useEffect(() => {
    if (statusData && location?.state?.isMoveCarerList) {
      setStatus(statusData);
    }
  }, [statusData, location?.state?.isMoveCarerList]);
  function onAddClick() {
    history.push(`${process.env.PUBLIC_URL}/add-carer`);
  }
  const onEdit = (row) => {
    history.push({
      pathname: `${process.env.PUBLIC_URL}/add-carer`,
      state: {
        data: row,
      },
    });
  };
  const onView = (row) => {
    if (isReportRoute && !isActiveCarersReport) {
      // Get current URL parameters to preserve filters when navigating back
      const currentParams = parseUrlParams();
      const preservedFilters = {
        progressStatus: currentParams.progressStatus,
        status: currentParams.status,
        grade: currentParams.grade,
        branch: currentParams.branch,
        carerType: currentParams.carerType,
        search: currentParams.search,
        month: currentParams.month,
        page: currentParams.page,
      };
      const carerName = `${row?.firstName || ""} ${row?.lastName || ""}`.trim();
      history.push({
        pathname: `${process.env.PUBLIC_URL}/reports/carers/reports-list`,
        state: {
          data: row.id,
          carerId: row.id,
          carerName: carerName,
          preservedFilters: preservedFilters, // Pass filters to preserve on back navigation
        },
      });
    } else {
      // Navigate to carer detail page for regular route / Active Carers
      history.push({
        pathname: `${process.env.PUBLIC_URL}/carer-detail`,
        state: {
          data: row,
          id: row?.id,
        },
      });
    }
  };
  const onMonthChange = (date) => {
    // Active Carers always keeps a month; clearing resets to current month
    const nextDate = !date && isActiveCarersReport ? moment(activeCarersMonth, "YYYY-MM-DD").toDate() : date || null;
    const monthValue = nextDate ? formatMonthParam(nextDate) : "";
    setSelectedMonth(nextDate);
    setMonth(monthValue);
    setCurrentPage(1);
    updateQueryParams({
      month: monthValue || undefined,
      page: 1,
    });
  };
  const updateQueryParams = (updates) => {
    const hashParams = {
      page: currentPage,
      grade: grade?.value,
      branch: branch?.value,
      carerType: carerType?.value,
      isCompliant: isCompliant?.value,
      searchText: searchText,
      month: month,
      pathname: location.pathname,
    };

    // Add status or progressStatus based on route
    // Use value from updates if provided, otherwise use state
    // Only include in hash if it has a value (not undefined, null, or empty string)
    if (isReportRoute) {
      // Check if progressStatus is explicitly in updates (even if undefined/null)
      if ("progressStatus" in updates) {
        if (updates.progressStatus) {
          hashParams.progressStatus = updates.progressStatus;
        }
        // If updates.progressStatus is explicitly undefined/null/empty, don't add it (will be removed from URL)
      } else {
        // If not in updates, use state value
        if (progressStatus?.value) {
          hashParams.progressStatus = progressStatus.value;
        }
      }
    } else {
      // Check if status is explicitly in updates (even if undefined/null)
      if ("status" in updates) {
        if (updates.status) {
          hashParams.status = updates.status;
        }
        // If updates.status is explicitly undefined/null/empty, don't add it (will be removed from URL)
      } else {
        // If not in updates, use state value
        if (status?.value) {
          hashParams.status = status.value;
        }
      }
    }

    // Spread other updates (page, grade, branch, etc.) after handling status/progressStatus
    Object.keys(updates).forEach((key) => {
      if (key !== "progressStatus" && key !== "status") {
        hashParams[key] = updates[key];
      }
    });
    updateHash(hashParams);
  };
  const onGradeChange = (grade) => {
    setGrade(grade);
    setCurrentPage(1);
    updateQueryParams({
      grade: grade?.value,
    });
  };
  const onCarerTypeChange = (carerType) => {
    setCarerType(carerType);
    setCurrentPage(1);
    updateQueryParams({
      carerType: carerType?.value,
    });
  };
  const onBranchChange = (branch) => {
    setBranch(branch);
    setCurrentPage(1);
    updateQueryParams({
      branch: branch?.value,
    });
  };
  const onStatusChange = (status) => {
    setStatus(status);
    setCurrentPage(1);
    updateQueryParams({
      status: status?.value,
      page: 1,
    });
  };
  const onProgressStatusChange = (progressStatus) => {
    setProgressStatus(progressStatus);
    setCurrentPage(1);
    // When "All" is selected, progressStatus is undefined, so explicitly pass undefined to remove it from URL
    const progressStatusValue = progressStatus?.value || undefined;
    updateQueryParams({
      progressStatus: progressStatusValue,
      page: 1,
    });
  };
  const onComplianceChange = (isCompliant) => {
    setIsCompliant(isCompliant);
    setCurrentPage(1);
    updateQueryParams({
      isCompliant: isCompliant?.value,
    });
  };
  const onSearchChange = (searchText) => {
    setSearchText(searchText);
    setCurrentPage(1);
    updateQueryParams({
      searchText: searchText,
    });
  };
  const onPageChanged = (page) => {
    setCurrentPage(page);
    updateQueryParams({
      page,
    });
  };
  const onEmail = (selectedRows) => {
    setEmailModal(true);
  };
  const onSms = () => {
    setSmsModal(true);
  };
  function onNote() {
    setNoteModal(true);
  }
  function onExport() {
    setLoading(true);
    if (isReportRoute) {
      let params = {
        search: searchText ?? "",
        branchId: isActiveCarersReport ? null : (branch?.id ?? null),
        month: requestMonth,
      };
      if (!isActiveCarersReport) {
        params.progressStatus = progressStatus?.value ?? undefined;
      }
      if (isActiveCarersReport) {
        params.rotaStatuses = ["ACTIVE", "COMPLETED"];
      }
      exportCarerProgressReportAPI(params, (data, error) => {
        if (error === null && data.fileUrl) {
          openLinkInNewTab(data.fileUrl);
        }
        setLoading(false);
      });
    } else {
      let params = {
        search: searchText,
        status: status?.value ?? statusData?.value ?? ServerStatusType.active,
        gradeId: grade?.id ?? null,
        carerTypeId: carerType?.id ?? null,
        month: month || null,
      };
      if (isCompliant?.value === "YES") {
        params.isCompliant = true;
      } else if (isCompliant?.value === "NO") {
        params.isCompliant = false;
      } else {
        params.isCompliant = undefined;
      }
      exportCarerAPI(params, (data, error) => {
        if (error === null) {
          window.open(data.fileUrl, "default");
        }
        setLoading(false);
      });
    }
  }

  // API----------------------------------------------------------->
  const callCarerListApi = () => {
    scrollToTop();
    if (isCheckToList(UserPermissionType.carer)) {
      let selectedStatus = isActiveCarersReport
        ? null
        : isReportRoute
          ? ServerStatusType.active
          : (status?.value ?? statusData?.value ?? ServerStatusType.active);
      let params = {
        pageInfo: {
          pageIndex: currentPage,
          itemsPerPage: PER_PAGE_ITEMS,
        },
        sorting: {
          field: sortId ?? null,
          order: sortOrder ?? null,
        },
        search: searchText ?? null,
        status: selectedStatus && selectedStatus !== "" ? [selectedStatus] : [],
        gradeId: grade?.id ?? null,
        branchId: isActiveCarersReport ? null : (branch?.id ?? null),
        carerTypeId: carerType?.id ?? null,
        month: requestMonth,
        // isCompliant: isCompliant === "YES" ? true : false,
      };
      if (isCompliant?.value === "YES") {
        params.isCompliant = true;
      } else if (isCompliant?.value === "NO") {
        params.isCompliant = false;
      } else {
        params.isCompliant = undefined;
      }
      if (isReportRoute) {
        params.isReportGenerated = true;
        if (!isActiveCarersReport) {
          params.progressStatus = progressStatus?.value ?? null;
        }
      }
      if (isActiveCarersReport) {
        params.rotaStatuses = ["ACTIVE", "COMPLETED"];
      }
      carerListApi(params, (data, error) => {
        if (error === null) {
          setCarerList(data?.list);
          // if (currentPage === 1) {
          setTotalItems(data?.pageInfo?.totalItems ?? 0);
          // } else {
          //   showErrorToast(error.message);
          // }
        }
        setInitScreen(false);
      });
    } else {
      setInitScreen(false);
    }
  };
  return (
    <React.Fragment>
      <Head title={pageTitle} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="flex-wrap">
            <BlockHeadContent>
              <BlockTitle page>{pageTitle === "Carers" ? "Carer" : pageTitle}</BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {totalItems} carer</p>
              </BlockDes>
              {/* <p>{data?.auth?.sessionUser?.email}</p> */}
            </BlockHeadContent>
            <BlockHeadContent className="ms-auto">
              <div className="d-flex flex-column align-items-center align-items-lg-end">
                <div className="d-flex align-items-center justify-content-center justify-content-lg-end flex-wrap">
                  <span className="p-1">
                    <FormInput
                      labelGroupClass="m-0"
                      value={searchText ?? ""}
                      placeholder="Search Carer"
                      onTextChange={onSearchChange}
                    />
                  </span>
                  <span className="p-1">
                    <FormDatePicker
                      selected={pickerMonth}
                      onChange={onMonthChange}
                      showMonthYearPicker
                      isClearable={!isActiveCarersReport}
                      maxDate={new Date()}
                      placeholderText="Select Month"
                    />
                  </span>
                  {!isActiveCarersReport && (
                    <span className="p-1">
                      <BranchDropDown
                        value={branch}
                        isClearable
                        isShowAll
                        className="w-225px"
                        onSelect={(e) => {
                          onBranchChange(e);
                        }}
                      />
                    </span>
                  )}
                  {!isReportRoute && (
                    <span className="p-1">
                      <GradeTypeDropDownWithoutCarer
                        isShowAll
                        value={grade}
                        className="w-225px"
                        selectedId={grade?.id}
                        onSelect={(selectedGrade) => onGradeChange(selectedGrade)}
                      />
                    </span>
                  )}
                  {!isReportRoute && (
                    <span className="p-1">
                      <CarerTypeDropDown
                        value={carerType}
                        placeholder={"Carer Type"}
                        className="w-150px"
                        isClearable
                        onSelect={(selectedCarerType) => onCarerTypeChange(selectedCarerType)}
                      />
                    </span>
                  )}
                  {isReportRoute && !isActiveCarersReport && (
                    <span className="p-1">
                      <ReportStatusDropdown
                        value={progressStatus}
                        className="w-125px"
                        isShowAll={true}
                        onSelect={(e) => {
                          onProgressStatusChange(e);
                        }}
                      />
                    </span>
                  )}
                  {!isReportRoute && (
                    <span className="p-1">
                      <StatusActiveDropDown
                        value={status}
                        isForCarer={true}
                        className="w-125px"
                        onSelect={(e) => {
                          onStatusChange(e);
                        }}
                      />
                    </span>
                  )}
                  {!isReportRoute && (
                    <span className="p-1">
                      <IsCompliantDropdown
                        value={isCompliant}
                        className="w-150px"
                        onSelect={(e) => {
                          onComplianceChange(e);
                        }}
                      />
                    </span>
                  )}
                  {isReportRoute && isAllowToAccess(UserPermissionType.carer, UserActionType.export) && (
                    <span className="p-1">
                      <ImportExportButton
                        title={"Export"}
                        onClick={() => onExport()}
                        iconName={"arrow-up"}
                        loading={loading}
                      />
                    </span>
                  )}
                  {!isReportRoute && isAllowToAccess(UserPermissionType.carer, UserActionType.add) && (
                    <span className="ps-1">
                      <ImportExportButton addButton title={"Add"} onClick={() => onAddClick()} iconName={"plus"} />
                    </span>
                  )}
                  {isRowSelected && (
                    <span className="p-1 d-flex align-items-center">
                      <MoreOptions
                        className="text-bg-light"
                        options={[
                          {
                            icon: "emails",
                            text: "Email",
                            action: () => {
                              onEmail(selectedRows);
                            },
                          },
                          {
                            icon: "chat",
                            text: "Sms",
                            action: () => {
                              onSms(selectedRows);
                            },
                          },
                          {
                            icon: "notes-alt",
                            text: "Note",
                            action: () => {
                              onNote(selectedRowIds);
                            },
                          },
                        ]}
                      />
                    </span>
                  )}
                </div>
                {!isReportRoute && (
                  <div className="d-flex align-items-center justify-content-center justify-content-lg-end flex-wrap">
                    {isAllowToAccess(UserPermissionType.carer, UserActionType.import) && (
                      <span className="p-1">
                        <ImportExportButton title={"Import"} iconName={"arrow-down"} onClick={onImport} />
                      </span>
                    )}
                    {isAllowToAccess(UserPermissionType.carer, UserActionType.export) && (
                      <span className="p-1">
                        <ImportExportButton
                          title={"Export"}
                          onClick={() => onExport()}
                          iconName={"arrow-up"}
                          loading={loading}
                        />
                      </span>
                    )}
                  </div>
                )}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard>
            <ReactDataTable
              data={carerList}
              keyField="id"
              columns={carerTableColumns(onEdit, onView, isReportRoute && !isActiveCarersReport)}
              isAllowed={isCheckToList(UserPermissionType.carer)}
              className={"carerListTable"}
              totalItemCount={totalItems}
              {...(!(isReportRoute && !isActiveCarersReport) && {
                selectableRowsNoSelectAll: true,
                selectableRows: true,
                onRowSelected: (row) => {
                  setSelectedRows(row.selectedRows);
                },
              })}
              pageNum={currentPage}
              pagination
              onPageChanged={onPageChanged}
              onRowClicked={(row) => isAllowToAccess(UserPermissionType.carer, UserActionType.detail) && onView(row)}
              onSort={(id) => {
                setSortId(id);
                const newSortOrder = sortOrder === "desc" ? "asc" : "desc";
                setSortOrder(newSortOrder);
              }}
            />
          </PreviewCard>
        </Block>
        <SendEmailModal
          visible={emailModal}
          item={emailList}
          onClosed={() => {
            setEmailModal(false);
            // setSelectedRows();
          }}
          onSaved={() => {
            //  loadBranch();
          }}
        />
        <Sms
          visible={smsModal}
          item={selectedRows}
          onClosed={() => {
            setSmsModal(false);
          }}
          onSaved={() => {
            //  loadBranch();
          }}
        />
        <AddNotes
          visible={noteModal}
          parents={selectedRowIds}
          type={NoteUserType.carer}
          onClosed={() => {
            setNoteModal(false);
            // setSelectedRows();
          }}
          onSaved={() => {
            // loadCarerNote();
            // loadClientNote();
          }}
        />
      </Content>
      <LoadingComponent isLoading={initScreen} />
      <ImportFileModal
        isOpen={importModalOpen}
        toggle={() => setImportModalOpen(!importModalOpen)}
        title="Carers"
        callCarerListApi={callCarerListApi}
      />
    </React.Fragment>
  );
};
export default CarerList;
